module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "sec_chap"
  }, [_vm._v("List of Archival Maps")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Map 1A: The Western Front’s Situation at 2000 hours on 5 July 1941. The Western Front’s Left Wing")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Map 1B: The Western Front’s Situation at 2000 hours on 5 July 1941. The Western Front’s Right Wing")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Map 2: The Correlation of Forces in the Western Front’s sector on 12 July 1941")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Map 3A: Situation on 20 July 1941. The Western Front’s Left-Wing")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Map 3B: Situation on 20 July 1941. The Western Front’s Right Wing.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Map 3C: The Dispositions of the 19th and 4th Reserve Armies on 21 July 1941")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Map 5: The Basing of the Western Front’s Air Forces (VVS) on 1 August 1941")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Map 6A: Situation from 6 through 8 August 1941. The Western Front’s Left Wing")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Map 6B: Situation from 6 through 8 August 1941. The Western Front’s Center.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Map 6C: Situation from 6 through 8 August 1941. The Western Front’s Right Wing.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Map 7: The Western Front’s Situation and Force Missions according to Combat Order No. 01/op of 15 August 1941")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Map 8: 20th Army’s Combat Operations from 6 through 8 August 1941")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Map 9: The Western Front’s Combat Operations from 24 August through 10 September 1941")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Map 10A: Situation on 4 September 1941. The Briansk Front’s Left Wing.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Map 10B: Situation on 4 September 1941. The Briansk Front’s Right Wing.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Map 11: The Southwestern Front’s Situation Late on 9 September 1941 600")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c22abfd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_List_Maps.vue
// module id = 75
// module chunks = 0